import httpService from './http.service';
const getPossibleImages = async inputModel => {
  try {
    let response = await httpService.postByObject(
      '/ImageSource/GetPossibleImages',
      inputModel
    );

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export { getPossibleImages };
